import { useStripeModule } from '../../../../../context/stripe';

import type { StripeData } from '../StripeWizard';
import type { WizardStepComponent } from '../Wizard';

import { useEffect } from 'react';
import { useDomainSelection } from '../../../../../context';
import { useStripeAppearance } from '../../UseStripeAppearance';
import { AddressStep } from './Address.step';

export const AddressElementWrapper: WizardStepComponent<StripeData> = (
  props,
) => {
  const appearance = useStripeAppearance();
  const { Elements, stripe } = useStripeModule();
  const options = {
    appearance,
    loader: 'never',
  } as const;
  const { currentAccessibeAccount } = useDomainSelection();

  useEffect(() => {
    if (currentAccessibeAccount?.stripeCustomerId) {
      props.next();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentAccessibeAccount?.stripeCustomerId]);

  return (
    <Elements options={options} stripe={stripe!}>
      <AddressStep {...props} />
    </Elements>
  );
};
